import { render, staticRenderFns } from "./TheCampaignCardTagsItem.vue?vue&type=template&id=47a89ef3"
import script from "./TheCampaignCardTagsItem.vue?vue&type=script&lang=js"
export * from "./TheCampaignCardTagsItem.vue?vue&type=script&lang=js"
import style0 from "./TheCampaignCardTagsItem.vue?vue&type=style&index=0&id=47a89ef3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports